// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import translate from "@insite/client-framework/Translate";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/Handlers/UpdateDraftParameter";
import { useTrailerTrackingV2State } from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/TrailerTrackingV2Hooks";
import { useFilterDrawerContext } from "@store/Library/Components/FilterDrawerAndButton";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import SearchShipToField, { SearchShipToFieldPresentationProps } from "@store/Library/Components/SearchShipToField";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC, useMemo } from "react";

export interface TrailerTrackingV2FilterFieldShipToProps {}

export interface TrailerTrackingV2FilterFieldShipToStyles {
    searchShipToField?: SearchShipToFieldPresentationProps;
}

export const trailerTrackingV2FilterFieldShipToStyles: TrailerTrackingV2FilterFieldShipToStyles = {
    searchShipToField: filterDrawerProps.dynamicDropdown,
};

const styles = trailerTrackingV2FilterFieldShipToStyles;

const TrailerTrackingV2FilterFieldShipTo: FC<TrailerTrackingV2FilterFieldShipToProps> = () => {
    const dispatch = useAppDispatch();
    const { scrollElement } = useFilterDrawerContext();
    const { customerSequence } = useTrailerTrackingV2State().draftParameter;
    const id = useMemo(uniqueId, []);

    return (
        <FilterDrawerSection title={translate("Ship To")} labelFor={id}>
            <SearchShipToField
                {...styles.searchShipToField}
                onSelectionChange={customerSequence => {
                    dispatch(updateDraftParameter({ customerSequence }));
                }}
                placeholder={translate("Search or Select Ship To")}
                scrollElement={scrollElement}
                selected={customerSequence}
                uid={id}
            />
        </FilterDrawerSection>
    );
};

export default TrailerTrackingV2FilterFieldShipTo;
